import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { useHomeController } from "./context/home-controller";
import SectionBanner from "./sections/section-banner";
import SectionNews from "./sections/section-news";
import SectionAccess from "./sections/section-access";
import SectionImportantLinks from "./sections/section-important-links";
import SectionPublicationsTabs from "./sections/section-publications-tabs";

export function HomeComponent() {
    const [initialLoading, setInitialLoading] = useState(true);
    const { getData } = useHomeController();

    useEffect(() => {
        const onInit = async () => {
            await getData();
            setInitialLoading(false);
        };
        onInit();
    }, []);

    return (
        <React.Fragment>
            {initialLoading ? (
                <Box sx={{ py: 4 }}>
                    <Skeleton variant="rectangular" width="100%" height={500} sx={{ borderRadius: 2, mb: 4 }} />
                    <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />
                </Box>
            ) : (
                <Box sx={{ py: 0 }}>
                    <SectionBanner />
                    <SectionNews />
                    <SectionAccess />
                    <SectionImportantLinks />
                    <SectionPublicationsTabs />
                </Box>
            )}
        </React.Fragment>
    );
}